/* RIDGEFORCE theme behaviour: mobile nav, product gallery, variant switching */
(function () {
  "use strict";

  var burger = document.querySelector("[data-rf-burger]");
  var mobileNav = document.querySelector("[data-rf-mobile-nav]");
  if (burger && mobileNav) {
    burger.addEventListener("click", function () {
      var open = mobileNav.hasAttribute("hidden");
      if (open) mobileNav.removeAttribute("hidden");
      else mobileNav.setAttribute("hidden", "");
      burger.setAttribute("aria-expanded", String(open));
    });
  }

  var mainImage = document.getElementById("rfMainImage");
  document.querySelectorAll("[data-rf-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute("data-rf-thumb");
      var alt = thumb.querySelector("img") && thumb.querySelector("img").getAttribute("alt");
      if (alt) mainImage.alt = alt;
      document.querySelectorAll("[data-rf-thumb]").forEach(function (t) { t.removeAttribute("aria-current"); });
      thumb.setAttribute("aria-current", "true");
    });
  });

  var variantsEl = document.querySelector("[data-rf-variants]");
  if (!variantsEl) return;

  var variants;
  try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

  var selectors = Array.prototype.slice.call(document.querySelectorAll("[data-rf-option-selector]"));
  var idInput = document.querySelector("[data-rf-variant-id]");
  var priceEl = document.querySelector("[data-rf-price]");
  var addBtn = document.querySelector(".rf-product__add");

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat("en-ZA", { style: "currency", currency: "ZAR" }).format(cents / 100);
    } catch (e) {
      return "R" + (cents / 100).toFixed(2);
    }
  }

  function update() {
    var chosen = selectors.map(function (s) { return s.value; });
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    });
    if (!match) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
      return;
    }

    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? "Add to cart" : "Sold out";
    }

    if (mainImage && match.featured_image && match.featured_image.src) {
      mainImage.src = match.featured_image.src;
    }
  }

  selectors.forEach(function (s) { s.addEventListener("change", update); });
})();
